import { __extends, __assign } from 'tslib';
import React__default from 'react';
import 'react-dates/initialize';
import { SingleDatePicker as SingleDatePicker$1 } from 'react-dates';
import { propTypes, defaultProps } from './SingleDatePicker.types.js';
import './SingleDatePicker.scss.js';
import { Icon } from '../Icon/Icon.component.js';

var SingleDatePicker = /** @class */ (function (_super) {
    __extends(SingleDatePicker, _super);
    function SingleDatePicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleDatePicker.prototype.render = function () {
        var label = this.props.label;
        return (React__default.createElement("div", { className: "SingleDatePicker" },
            label && (React__default.createElement("label", { className: "SingleDatePicker_label" }, label)),
            React__default.createElement(SingleDatePicker$1, __assign({ navPrev: React__default.createElement(Icon, { className: "SingleDatePicker_arrowIcon", size: 24, name: "ChevronLeftIcon", alt: "LeftIcon" }), navNext: React__default.createElement(Icon, { className: "SingleDatePicker_arrowIcon", size: 24, name: "ChevronRightIcon", alt: "RightIcon" }), hideKeyboardShortcutsPanel: true }, this.props))));
    };
    SingleDatePicker.displayName = 'SingleDatePicker';
    SingleDatePicker.propTypes = propTypes;
    SingleDatePicker.defaultProps = __assign({}, defaultProps);
    return SingleDatePicker;
}(React__default.Component));

export default SingleDatePicker;
export { SingleDatePicker };
